<template>
    <svg
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 442.07 210.51">
        <defs>
            <clipPath id="clippath">
                <rect
                    x="21.23"
                    y="80.26"
                    width="118.08"
                    height="119.13"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-1">
                <rect
                    x="179.42"
                    y="176.03"
                    width="79.76"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-2">
                <rect
                    x="179.42"
                    y="176.03"
                    width="3.84"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-3">
                <rect
                    x="187.86"
                    y="176.03"
                    width="3.84"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-4">
                <rect
                    x="196.29"
                    y="176.03"
                    width="3.86"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-9">
                <rect
                    x="238.46"
                    y="176.03"
                    width="3.86"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-10">
                <rect
                    x="246.91"
                    y="176.03"
                    width="3.84"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-11">
                <rect
                    x="255.34"
                    y="176.03"
                    width="3.84"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
        </defs>
        <g id="Layer_2-2">
            <rect
                id="Rectangle_329"
                x="285.42"
                y="56.48"
                width="156.07"
                height="21.3"
                fill="#f47941"
                stroke-width="0" />
            <path
                id="Path_2338"
                d="m338.28,61.72c-2.09,0-3.79,1.7-3.79,3.79s2.86,5.06,3.88,6.72c1.01-1.67,3.7-4.59,3.7-6.72s-1.7-3.78-3.79-3.79m0,5.42c-.96,0-1.73-.78-1.73-1.74s.78-1.73,1.74-1.73,1.73.78,1.73,1.74h0c0,.96-.78,1.73-1.74,1.73"
                fill="#fff"
                stroke-width="0" />
            <text
                transform="translate(346.24 70.93)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="10"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    You are here
                </tspan>
            </text>
            <rect
                x="157"
                y="67.54"
                width="128.32"
                height="65.42"
                rx="7.81"
                ry="7.81"
                fill="#ccc"
                opacity=".13"
                stroke-width="0" />
            <path
                id="Path_2278"
                d="m138.16,21.11c9.5,0,17.19,7.7,17.2,17.2v152.93c0,9.5-7.7,17.19-17.2,17.2H18.88c-9.5,0-17.19-7.7-17.2-17.2V38.31c0-9.5,7.7-17.19,17.2-17.2h119.28Zm0-1.65H18.88C8.47,19.46.03,27.9.03,38.31v152.94c0,10.41,8.44,18.85,18.85,18.85h119.27c10.41,0,18.85-8.44,18.85-18.85V38.31c0-10.41-8.44-18.85-18.85-18.85"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2279"
                d="m155.6,56.49v-15.4c.56-13.68-8.91-20.46-21.35-21.54H21.35C9.51,19.6-.05,29.24,0,41.09v15.4s155.6,0,155.6,0Z"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2250"
                d="m423.22,21.52c9.5,0,17.19,7.7,17.2,17.2v152.93c-.01,9.49-7.7,17.19-17.2,17.2h-119.27c-9.49,0-17.19-7.71-17.2-17.2V38.72c0-9.5,7.7-17.19,17.2-17.2h119.27Zm0-1.65h-119.27c-10.41,0-18.85,8.44-18.85,18.85v152.94c0,10.41,8.44,18.85,18.85,18.85h119.27c10.41,0,18.85-8.44,18.85-18.85V38.72c0-10.41-8.44-18.85-18.85-18.85"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2251"
                d="m441.59,57.3v-15.34c.09-13.33-9.52-22.76-21.44-21.46h-113.38c-5.31-.08-10.48,1.7-14.63,5.02-4.56,3.93-6.82,9.95-6.82,16.44v15.34h156.27Z"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2252"
                d="m353.24,22.65v7.7h7.19l-.51-7.18s-6.68-.52-6.68-.52Z"
                fill="#cfd5ea"
                stroke-width="0" />
            <path
                id="Path_2257"
                d="m369.1,17.87c.28,0,.51.23.51.51v8.53c0,.28-.23.51-.51.51h-8.49c-.28,0-.51-.23-.51-.51s.23-.51.51-.51h7.98v-8.02c0-.28.23-.51.51-.51"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2258"
                d="m360.42,30.35h-7.19c-.28,0-.51-.23-.51-.51h0v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.68-1.02h6.16v-6.16h-6.16v6.16Z"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2280"
                d="m147.42,94.15l-8.74,8.62h0s-.06.06-.09.1l-.04.04c-.21.25-.35.54-.41.86h0c0,.06-.02.12-.03.19s0,.13,0,.19v.19c0,.06.02.12.03.19h0c.06.32.2.61.41.86,0,.02.03.03.04.04.03.03.06.07.09.1h0l8.74,8.62c.77.76,2.01.75,2.77-.02.76-.77.75-2.01-.02-2.76h0l-5.35-5.28h14.35c1.08,0,1.96-.88,1.96-1.96s-.88-1.96-1.96-1.96h-14.34l5.35-5.28c.79-.74.82-1.98.08-2.76-.74-.79-1.98-.82-2.76-.08-.02.02-.05.05-.07.07"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2281"
                d="m173.1,104.16c0,1.08-.88,1.95-1.95,1.96h-2.81c-1.08,0-1.95-.88-1.95-1.96s.88-1.96,1.95-1.96h2.81c1.08,0,1.95.88,1.95,1.96"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2282"
                d="m230.54,103.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2283"
                d="m209.19,103.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2271"
                d="m241.22,103.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_690"
                d="m419.08,166.38l-59.11,33.17c-2.7,1.51-6.11.55-7.62-2.14l-46.11-82.17c-1.51-2.7-.55-6.11,2.14-7.62l44.08-24.74c.18-.09.38-.11.57-.07l32.43,12.48c.14.07.26.18.33.32l35.46,63.19c1.5,2.69.54,6.08-2.15,7.57h-.01"
                fill="#ced5ea"
                stroke-width="0" />
            <path
                id="Path_691"
                d="m404.15,188l-67.78.28c-3.09,0-5.61-2.48-5.62-5.57l-.39-94.23c0-3.09,2.48-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.46c0,3.08-2.49,5.57-5.56,5.58h-.01"
                fill="#f0f1f9"
                stroke-width="0" />
            <path
                id="Path_692"
                d="m404.15,188l-67.78.28c-3.09,0-5.61-2.48-5.62-5.57l-.39-94.23c0-3.09,2.48-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.46c0,3.08-2.49,5.57-5.56,5.57h-.01,0Z"
                fill="none"
                stroke="#cfd5ea"
                stroke-miterlimit="10" />
            <path
                id="Path_693"
                d="m408.71,110.51l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.22-.36.37-.61.4"
                fill="#f0f1f9"
                stroke-width="0" />
            <path
                id="Path_694"
                d="m408.71,110.51l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.22-.36.37-.62.4h0Z"
                fill="none"
                stroke="#cfd5ea"
                stroke-miterlimit="10" />
            <rect
                id="Rectangle_104"
                x="305.51"
                y="77.71"
                width="116.43"
                height="117.55"
                fill="none"
                stroke-width="0" />
            <path
                id="Rectangle_108"
                d="m319.27,88.34h98.78c4.31,0,7.81,3.21,7.81,7.17v15.26c0,3.96-3.5,7.17-7.81,7.17h-98.78c-4.31,0-7.81-3.21-7.81-7.17v-15.26c0-3.96,3.5-7.17,7.81-7.17Z"
                fill="#f0f1f9"
                isolation="isolate"
                opacity=".81"
                stroke="#405184"
                stroke-miterlimit="10"
                stroke-width=".25" />
            <path
                id="Path_708"
                d="m412.49,193.16h-88.56c-3.45,0-8.28.06-10.82-2.18-2.21-1.94-2.03-6.28-2.03-9.64v-5.95c0-3.06-.27-6.99,2.03-9.32,2.12-2.15,7.05-2.5,10.82-2.5h88.56c3.89,0,8.25-.55,10.82,2.2,1.73,1.84,2.05,6.68,2.05,9.63v5.95c0,3.38.09,7.29-3.13,10.24s-6.31,1.58-9.73,1.58"
                fill="#f0f1f9"
                isolation="isolate"
                opacity=".8"
                stroke-width="0" />
            <path
                id="Rectangle_110"
                d="m318.87,163.57h98.78c4.31,0,7.81,3.21,7.81,7.17v15.26c0,3.96-3.5,7.17-7.81,7.17h-98.78c-4.31,0-7.81-3.21-7.81-7.17v-15.26c0-3.96,3.5-7.17,7.81-7.17Z"
                fill="none"
                stroke="#44b649"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <path
                id="Path_2284"
                d="m328.57,172.41c-.11,0-.21-.04-.29-.12-2.31-2.3-6.04-2.3-8.35,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,2.63-2.62,6.89-2.62,9.52,0,.16.16.16.42,0,.58-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2285"
                d="m320.8,173.58c-.11,0-.21-.04-.29-.12-.16-.16-.16-.42,0-.58,1.99-1.98,5.2-1.98,7.19,0,.16.16.17.42,0,.58-.16.16-.42.17-.58,0h0c-1.66-1.66-4.36-1.66-6.02,0-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2286"
                d="m326.24,174.74c-.11,0-.21-.04-.29-.12-1.03-.99-2.66-.99-3.69,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,1.36-1.3,3.5-1.3,4.86,0,.16.16.16.42,0,.58h0c-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2287"
                d="m325.41,184.69h-2.99c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h2.99c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2288"
                d="m323.92,184.55c-.18,0-.33-.15-.33-.33v-.92c0-.18.15-.33.33-.33s.33.15.33.33v.92c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2289"
                d="m323.61,179.78c-.11,0-.21-.05-.27-.14l-1.07-1.56c-.1-.15-.06-.36.09-.46s.36-.06.46.09l1.07,1.56c.1.15.07.35-.08.46h0c-.06.04-.12.06-.19.06"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2290"
                d="m325.7,180.83s-.07,0-.11-.02l-1.49-.51c-.17-.06-.26-.25-.2-.42s.24-.26.41-.2h0l1.49.51c.17.06.26.25.2.42-.05.13-.17.22-.31.22"
                fill="#405184"
                stroke-width="0" />
            <g clip-path="url(#clippath)">
                <g id="Group_148">
                    <path
                        id="Path_662"
                        d="m135.61,164.68l-59.11,33.17c-2.7,1.51-6.11.55-7.62-2.14L22.76,113.53c-1.51-2.7-.56-6.11,2.14-7.62l44.08-24.74c.18-.09.38-.11.57-.07l32.42,12.48c.14.07.26.18.33.32l35.46,63.19c1.5,2.68.54,6.07-2.15,7.57,0,0-.01,0-.02,0"
                        fill="#eff1fb"
                        stroke-width="0" />
                    <path
                        id="Path_663"
                        d="m135.61,164.68l-59.11,33.17c-2.7,1.51-6.11.55-7.62-2.14L22.76,113.53c-1.51-2.7-.56-6.11,2.14-7.62l44.08-24.74c.18-.09.38-.11.57-.07l32.42,12.48c.14.07.26.18.33.32l35.46,63.19c1.5,2.68.54,6.07-2.14,7.57,0,0-.01,0-.02.01Z"
                        fill="none"
                        stroke="#5c73b8"
                        stroke-dasharray="0 0 2 2"
                        stroke-linejoin="round" />
                    <path
                        id="Path_664"
                        d="m120.69,187.3l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c0-3.09,2.49-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.13.28.13.44l.3,72.46c0,3.07-2.48,5.57-5.56,5.58h-.02"
                        fill="#eff1fb"
                        stroke-width="0" />
                    <path
                        id="Path_665"
                        d="m120.69,187.3l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c0-3.09,2.49-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.13.28.13.44l.3,72.46c0,3.07-2.48,5.57-5.56,5.57,0,0-.01,0-.02,0Z"
                        fill="none"
                        stroke="#5c73b8"
                        stroke-dasharray="0 0 2 2"
                        stroke-linejoin="round" />
                    <path
                        id="Path_666"
                        d="m123.82,107.98l-14.42.06c-3.91.02-7.12-3.54-7.14-7.92l-.07-17.55c0-.26.17-.49.41-.58.25-.08.52-.01.71.16l21.01,24.8c.17.18.21.44.09.66-.12.21-.34.35-.58.37"
                        fill="#eff1fb"
                        stroke-width="0" />
                    <path
                        id="Path_667"
                        d="m123.82,107.98l-14.42.06c-3.91.02-7.12-3.54-7.14-7.92l-.07-17.55c0-.26.17-.49.41-.58.25-.08.52-.01.71.16l21.01,24.8c.17.18.21.44.09.66-.12.21-.34.35-.58.37Z"
                        fill="none"
                        stroke="#5c73b8"
                        stroke-dasharray="0 0 2 2"
                        stroke-linejoin="round" />
                </g>
            </g>
            <path
                id="Path_2291"
                d="m321.73,177.28c-.09,0-.17-.04-.23-.1l-.99-.99c-.13-.13-.13-.34,0-.47s.34-.13.47,0h0l.99.99c.13.13.13.34,0,.47-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2292"
                d="m325.95,177.28c-.18,0-.33-.15-.33-.33,0-.09.03-.17.1-.23l1.05-1.05c.13-.13.34-.13.47,0s.13.34,0,.47l-1.05,1.05c-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2293"
                d="m323.88,183.52c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2294"
                d="m323.88,180.5c-.41,0-.74-.33-.74-.74s.33-.74.74-.74.74.33.74.74-.33.74-.74.74m0-.82s-.08.04-.08.08c0,.09.16.09.16,0,0-.04-.03-.08-.08-.08h0"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2295"
                d="m323.88,183.52c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2296"
                d="m323.88,177.71c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2297"
                d="m323.88,182.86c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2298"
                d="m326.66,180.07h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2299"
                d="m321.52,180.07h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2352"
                d="m41.51,180.72h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2264"
                d="m298.16,103.73c0-1.08.88-1.95,1.95-1.96h2.81c1.08,0,1.95.88,1.95,1.96s-.88,1.96-1.95,1.96h-2.81c-1.08,0-1.95-.88-1.95-1.96"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2265"
                d="m281.09,103.76v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2406"
                d="m290.21,103.76v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2266"
                d="m270.81,103.76v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2302"
                d="m219.86,103.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2276"
                d="m260.28,104.19c.3-.14.59-.3.86-.5v1.24c0,.28-.2.62-.72.96.57-.03,1.13.05,1.67.24v-4.05c0-.96-.83-1.67-1.81-2.11-2.51-.99-5.29-.99-7.8,0-.98.44-1.81,1.16-1.81,2.11v8.57c0,.96.83,1.67,1.81,2.11,1.24.51,2.56.76,3.9.74.49,0,.99-.03,1.48-.09-.3-.26-.56-.55-.77-.88-.23.01-.47.02-.71.02-1.2.03-2.39-.2-3.5-.65-.92-.42-1.25-.89-1.25-1.25v-1.24c.27.2.56.36.86.5,1.24.51,2.56.76,3.9.74h.03c-.03-.32-.03-.64,0-.95h-.03c-1.2.02-2.39-.2-3.5-.65-.92-.42-1.25-.89-1.25-1.25v-1.24c.27.2.56.36.86.5,1.23.51,2.56.77,3.9.74.25,0,.5,0,.74-.02.28-.42.64-.78,1.05-1.08-.59.1-1.19.15-1.79.15-1.2.02-2.39-.2-3.5-.65-.92-.42-1.25-.9-1.25-1.25v-1.24c.27.2.56.36.86.5,2.51.99,5.29.99,7.8,0m-8.66-2.11c0-.36.34-.83,1.25-1.25,2.25-.87,4.75-.87,7.01,0,.91.42,1.25.89,1.25,1.25s-.34.83-1.25,1.25c-2.25.87-4.75.87-7.01,0-.92-.42-1.25-.89-1.25-1.25"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2277"
                d="m263.56,109.58l-.14-.04s-.08-.03-.12-.05c-.3-.16-.4-.53-.24-.83h0l.07-.13c.16-.3.05-.67-.25-.83-.18-.1-.4-.1-.58,0l-.13.07s-.08.04-.12.05c-.32.09-.66-.09-.75-.41h0l-.04-.14c-.1-.32-.43-.51-.76-.41-.2.06-.35.21-.41.41l-.04.14s-.03.08-.05.12c-.16.3-.53.41-.83.24h0l-.13-.07c-.3-.16-.67-.05-.83.24-.1.18-.1.4,0,.58l.07.13s.04.08.05.12c.09.32-.09.66-.41.76h0l-.14.04c-.32.09-.51.43-.42.75.06.2.22.36.42.42l.14.04s.08.03.12.05c.3.16.41.53.25.82h0l-.07.13c-.16.3-.05.67.25.83.18.1.4.1.58,0l.13-.07s.08-.04.12-.05c.32-.1.66.09.76.41h0l.04.14c.1.32.43.51.76.41.2-.06.35-.21.41-.41l.04-.14s.03-.08.05-.12c.16-.3.53-.4.82-.24h0l.13.07c.3.16.67.05.83-.25.1-.18.1-.4,0-.58l-.07-.13s-.04-.08-.05-.12c-.09-.32.09-.66.41-.76l.14-.04c.32-.1.51-.43.41-.76-.06-.2-.21-.35-.41-.41m-2.89,2.01c-.79,0-1.43-.64-1.43-1.43s.64-1.43,1.43-1.43,1.43.64,1.43,1.43-.64,1.43-1.43,1.43h0"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2267"
                d="m320.29,103.86c-.51-.21-1.08.04-1.29.54-.16.4-.05.86.29,1.13l1.84,1.52c.27.22.42.54.42.89-.01.98.77,1.78,1.75,1.78h2.53c.99,0,1.79-.8,1.79-1.79v-2.74c0-.28-.11-.54-.3-.74l-.64-.29c-.17-.01-.34.02-.49.1-.82-.18-1.58-.59-2.18-1.18-.16-.02-.32,0-.46.06v-1.75c0-.52-.38-.96-.89-1.03-.25-.01-.49.05-.69.19-.11.1-.21.2-.3.32-.1.3-.13.61-.1.93v3l-.61-.51m.37,1.13c.23.19.57.16.76-.08.08-.1.12-.22.12-.34v-3.65c0-.2.16-.36.36-.36h.04c.19.03.33.2.32.39v2.67c0,.18.14.32.32.32s.32-.14.32-.32c0-.2.16-.36.36-.36h.04c.19.03.33.2.32.4v.5c0,.18.14.32.32.32.17,0,.31-.14.32-.32,0-.2.17-.36.37-.36h.03c.19.04.33.21.32.4v.5c0,.18.14.32.32.32.17,0,.31-.14.32-.32,0-.2.17-.36.37-.36.03,0,.06,0,.09.01.16.06.27.21.26.39v2.74c0,.63-.52,1.15-1.15,1.15h-2.49c-.63,0-1.14-.52-1.15-1.15,0-.53-.24-1.04-.65-1.38l-1.84-1.52c-.15-.14-.17-.37-.03-.53h0c.16-.18.43-.06.51,0l1.11.92v.02h0Z"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2268"
                d="m327.81,97.01c-.11,0-.21-.04-.29-.12-2.31-2.3-6.04-2.3-8.35,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,2.63-2.63,6.89-2.63,9.52,0,.16.16.16.42,0,.58-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2269"
                d="m326.65,98.18c-.11,0-.21-.04-.29-.12-1.66-1.66-4.36-1.66-6.02,0-.16.16-.42.17-.58,0-.16-.16-.17-.42,0-.58h0c1.99-1.98,5.2-1.98,7.19,0,.16.16.16.42,0,.58h0c-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2270"
                d="m325.48,99.34c-.11,0-.21-.04-.29-.12-1.02-1.02-2.67-1.02-3.69,0-.17.16-.43.15-.59-.02-.15-.16-.15-.4,0-.56,1.34-1.34,3.52-1.34,4.86,0,.16.16.16.42,0,.58-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1485"
                d="m363.09,1.39c9.41,0,17.03,7.63,17.03,17.03s-7.63,17.03-17.03,17.03-17.03-7.63-17.03-17.03h0c0-9.41,7.63-17.03,17.03-17.03"
                fill="#fff"
                stroke="#405184" />
            <rect
                id="Rectangle_308"
                x="365.56"
                y="8.8"
                width="7.19"
                height="7.19"
                fill="#95b1e8"
                stroke-width="0" />
            <rect
                id="Rectangle_309"
                x="352.92"
                y="20.67"
                width="7.19"
                height="7.19"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1487"
                d="m372.74,16.5h-7.19c-.28,0-.51-.23-.51-.51v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.68-1.02h6.17v-6.16h-6.17v6.16Z"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1488"
                d="m357.02,21.44c-.28,0-.51-.23-.51-.51v-8.53c0-.28.23-.51.51-.51h8.49c.28,0,.51.23.51.51s-.23.51-.51.51h-7.98v8.02c0,.28-.23.51-.51.51"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1489"
                d="m369.29,16.15c.28,0,.51.23.51.51v8.53c0,.28-.23.51-.51.51h-8.49c-.28,0-.51-.23-.51-.51s.23-.51.51-.51h7.98v-8.02c0-.28.23-.51.51-.51"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1490"
                d="m360.62,28.63h-7.19c-.28,0-.51-.23-.51-.51v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.67-1.02h6.16v-6.16h-6.16v6.16Z"
                fill="#405184"
                stroke-width="0" />
            <rect
                id="Rectangle_310"
                x="345.23"
                y=".57"
                width="35.71"
                height="35.71"
                fill="none"
                stroke-width="0" />
            <path
                id="Path_1563"
                d="m75.81,20.86c-.25-.26-.67-.27-.93-.01h0l-6.58,6.54c-.27.25-.28.66-.03.93.13.14.31.22.5.21.18,0,.35-.07.47-.2l6.58-6.52c.26-.25.27-.67.01-.93h-.01"
                fill="#5c73b8"
                stroke-width="0" />
            <g id="Group_715">
                <path
                    id="Path_2499"
                    d="m79.82.5c9.43,0,17.08,7.65,17.08,17.08s-7.65,17.08-17.08,17.08-17.08-7.65-17.08-17.08h0c0-9.43,7.64-17.08,17.08-17.08h0"
                    fill="#fff"
                    stroke="#405184"
                    stroke-miterlimit="10" />
                <path
                    id="Path_2512"
                    d="m77.34,23.59l-2.94,3.36c-.23.29-.18.71.1.94.27.22.66.19.9-.06l2.94-3.36c.23-.28.19-.7-.09-.94-.27-.22-.67-.2-.91.06"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2509"
                    d="m69.89,22.65c.17,0,.34-.07.47-.19l3.22-3.11c.27-.25.28-.67.03-.94s-.67-.28-.94-.03c0,0-.01.01-.02.02l-3.22,3.11c-.27.25-.29.66-.04.93.13.14.31.22.51.21"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2510"
                    d="m76.83,20.18c-.25-.26-.67-.27-.93-.01h0l-6.58,6.54c-.27.25-.28.66-.03.93.13.14.31.22.5.21.18,0,.35-.07.47-.2l6.58-6.52c.26-.25.27-.67.01-.93h-.01"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2505"
                    d="m90.49,8.17v-.11s-.01-.07-.02-.1c-.01-.04-.03-.07-.05-.11,0-.02-.01-.04-.02-.06l-.03-.03s-.05-.06-.08-.08c-.03-.03-.05-.05-.08-.07l-.03-.03s-.04-.01-.06-.02c-.03-.02-.07-.03-.11-.04-.03-.01-.07-.02-.11-.02h-.11s-.07,0-.11.01c-.02,0-.05,0-.07.01l-20.07,6.73c-.35.1-.55.47-.45.82.06.21.22.37.42.44l9.48,3.63,3.78,9.43c.1.25.35.42.62.42h.02c.28,0,.53-.19.61-.46l6.41-20.17s0-.05.01-.07c0-.04.01-.07.01-.11m-3.09,1.49l-8.04,8.17-7.61-2.91s15.65-5.26,15.65-5.26Zm-4.07,16.66l-3.02-7.55,8.04-8.17s-5.02,15.72-5.02,15.72Z"
                    fill="#405184"
                    stroke-width="0" />
            </g>
            <polygon
                points="83.26 26.33 80.26 18.76 88.32 10.61 83.26 26.33"
                fill="#fff"
                stroke-width="0" />
            <polygon
                points="87.36 9.67 79.32 17.84 71.71 14.93 87.36 9.67"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2307"
                d="m227.91,65.66c-.35-.14-.52-.53-.4-.89l.4-1.59,1.34,2.82s-1.34-.34-1.34-.34Z"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_708-2"
                d="m123.95,194.28H35.12c-3.46,0-8.3.06-10.86-2.18-2.21-1.94-2.04-6.28-2.04-9.64v-5.95c0-3.06-.27-6.99,2.04-9.32,2.13-2.15,7.07-2.5,10.86-2.5h88.83c3.91,0,8.27-.55,10.86,2.2,1.73,1.84,2.05,6.68,2.05,9.63v5.95c0,3.38.09,7.29-3.14,10.24s-6.33,1.58-9.75,1.58"
                fill="#f0f1f9"
                isolation="isolate"
                opacity=".8"
                stroke-width="0" />
            <path
                id="Rectangle_110-2"
                d="m30.02,164.69h98.78c4.31,0,7.81,3.21,7.81,7.17v15.26c0,3.96-3.5,7.17-7.81,7.17H30.02c-4.31,0-7.81-3.21-7.81-7.17v-15.26c0-3.96,3.5-7.17,7.81-7.17Z"
                fill="none"
                stroke="#44b649"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <path
                id="Path_2284-2"
                d="m39.72,173.53c-.11,0-.21-.04-.29-.12-2.31-2.3-6.04-2.3-8.35,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,2.63-2.62,6.89-2.62,9.52,0,.16.16.16.42,0,.58-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2285-2"
                d="m31.95,174.7c-.11,0-.21-.04-.29-.12-.16-.16-.16-.42,0-.58,1.99-1.98,5.2-1.98,7.19,0,.16.16.17.42,0,.58-.16.16-.42.17-.58,0h0c-1.66-1.66-4.36-1.66-6.02,0-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2286-2"
                d="m37.39,175.86c-.11,0-.21-.04-.29-.12-1.03-.99-2.66-.99-3.69,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,1.36-1.3,3.5-1.3,4.86,0,.16.16.16.42,0,.58h0c-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2287-2"
                d="m36.56,185.81h-2.99c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h2.99c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2288-2"
                d="m35.07,185.67c-.18,0-.33-.15-.33-.33v-.92c0-.18.15-.33.33-.33s.33.15.33.33v.92c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2289-2"
                d="m34.76,180.9c-.11,0-.21-.05-.27-.14l-1.07-1.56c-.1-.15-.06-.36.09-.46s.36-.06.46.09l1.07,1.56c.1.15.07.35-.08.46h0c-.06.04-.12.06-.19.06"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2290-2"
                d="m36.85,181.95s-.07,0-.11-.02l-1.49-.51c-.17-.06-.26-.25-.2-.42s.24-.26.41-.2h0l1.49.51c.17.06.26.25.2.42-.05.13-.17.22-.31.22"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2291-2"
                d="m32.88,178.4c-.09,0-.17-.04-.23-.1l-.99-.99c-.13-.13-.13-.34,0-.47s.34-.13.47,0h0l.99.99c.13.13.13.34,0,.47-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2292-2"
                d="m37.1,178.4c-.18,0-.33-.15-.33-.33,0-.09.03-.17.1-.23l1.05-1.05c.13-.13.34-.13.47,0s.13.34,0,.47l-1.05,1.05c-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2293-2"
                d="m35.03,184.64c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2294-2"
                d="m35.03,181.62c-.41,0-.74-.33-.74-.74s.33-.74.74-.74.74.33.74.74-.33.74-.74.74m0-.82s-.08.04-.08.08c0,.09.16.09.16,0,0-.04-.03-.08-.08-.08h0"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2295-2"
                d="m35.03,184.64c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2296-2"
                d="m35.03,178.83c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2297-2"
                d="m35.03,183.98c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2298-2"
                d="m37.81,181.19h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2299-2"
                d="m32.67,181.19h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <text
                transform="translate(336.05 182.28)"
                fill="#405184"
                font-family="SourceSansPro-BoldItalic, 'Source Sans Pro'"
                font-size="8"
                font-style="italic"
                font-weight="700"
                letter-spacing="-.01em">
                <tspan
                    x="0"
                    y="0">
                    Automation Signal
                </tspan>
            </text>
            <text
                transform="translate(47.1 182.28)"
                fill="#405184"
                font-family="SourceSansPro-BoldItalic, 'Source Sans Pro'"
                font-size="8"
                font-style="italic"
                font-weight="700"
                letter-spacing="-.01em">
                <tspan
                    x="0"
                    y="0">
                    Automation Signal
                </tspan>
            </text>
            <path
                id="Path_2313"
                d="m189.35,101.17c-2.99-.2-5.57,2.05-5.78,5.03-.2,2.99,2.05,5.57,5.03,5.78s5.57-2.05,5.78-5.03c.07-.99-.14-1.98-.59-2.86"
                fill="none"
                stroke="#555"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                id="Path_2314"
                d="m193.77,111.85c2.91.7,5.84-1.09,6.54-4s-1.09-5.84-4-6.54-5.84,1.09-6.54,4c-.23.96-.2,1.97.11,2.92"
                fill="none"
                stroke="#555"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <text
                transform="translate(164.65 118.95)"
                fill="#555"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="6"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Initiates Relationship
                </tspan>
            </text>
            <text
                transform="translate(242 119.03)"
                fill="#555"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="6"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Copies Data
                </tspan>
            </text>
            <path
                id="Path_2303"
                d="m221.41,74.2c-.13,0-.24-.09-.28-.21l-3.9-14.72c-.04-.15.05-.31.2-.35l7.67-2.04,4.22,3.01,2.96,11.15c.02.07,0,.15-.03.21-.04.07-.1.12-.18.14l-10.59,2.81h-.07Z"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2304"
                d="m224.98,57.55l3.8,2.71,2.81,10.6-9.95,2.64-3.73-14.08,7.07-1.87h0Zm.22-1.33h-.03l-7.9,2.1c-.48.13-.77.62-.64,1.1h0l3.9,14.72c.11.4.47.67.88.67.08,0,.16-.01.23-.03l10.59-2.81c.48-.12.77-.62.65-1.1h0l-3-11.32s-.02-.05-.04-.06l-4.57-3.26s-.04-.02-.06-.02"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2305"
                d="m229.14,74.32l-10.62-2.69c-.14-.05-.23-.2-.21-.35l3.74-14.77c.03-.13.15-.21.28-.21l7.76,1.96,2.23,4.68-2.83,11.18c-.03.12-.14.21-.27.21h-.07"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2306"
                d="m222.57,56.99l7.09,1.8,2,4.22-2.69,10.64-9.97-2.53,3.58-14.12h0Zm-.24-1.31c-.41,0-.78.28-.88.68l-3.74,14.76c-.12.48.17.98.66,1.1l10.62,2.69c.07.02.15.03.22.03.41,0,.77-.28.87-.68l2.87-11.35v-.07l-2.41-5.07s-.04-.05-.07-.06l-7.92-2c-.07-.02-.15-.03-.22-.03"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2307-2"
                d="m229.58,61.76c-.35-.14-.52-.53-.4-.89l.4-1.59,1.34,2.82s-1.34-.34-1.34-.34Z"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2308"
                d="m229.78,61.13l.04.07h-.02s-.02-.05-.02-.07m-.34-3.44h0s-.08.04-.09.08l-.75,2.96c-.21.68.16,1.41.84,1.64l2.4.61h.02s.07-.02.09-.04c.03-.03.03-.08,0-.11l-2.41-5.07s-.06-.06-.1-.06"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2309"
                d="m219.46,75.9c-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15,6.15,2.75,6.15,6.15-2.76,6.15-6.15,6.15"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2310"
                d="m219.46,64.21c3.06,0,5.54,2.48,5.53,5.54,0,3.06-2.48,5.53-5.54,5.53s-5.53-2.48-5.53-5.53,2.48-5.53,5.54-5.54m0-1.24c-3.74,0-6.77,3.03-6.77,6.77s3.03,6.77,6.77,6.77,6.77-3.03,6.77-6.77-3.03-6.77-6.77-6.77"
                fill="#555"
                stroke-width="0" />
            <line
                id="Line_84"
                x1="219.52"
                y1="66.83"
                x2="219.52"
                y2="72.66"
                fill="none"
                stroke="#555"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <line
                id="Line_86"
                x1="222.37"
                y1="69.53"
                x2="216.54"
                y2="69.53"
                fill="none"
                stroke="#555"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <text
                transform="translate(197.6 84.19)"
                fill="#555"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="8"
                font-weight="600"
                letter-spacing="-.02em">
                <tspan
                    x="0"
                    y="0">
                    Creates Project
                </tspan>
            </text>
            <text
                transform="translate(336.05 101.72)"
                fill="#405184"
                font-family="SourceSansPro-BoldItalic, 'Source Sans Pro'"
                font-size="8"
                font-style="italic"
                font-weight="700"
                letter-spacing="-.01em">
                <tspan
                    x="0"
                    y="0">
                    Create Related Project
                </tspan>
                <tspan
                    x="0"
                    y="8">
                    Button
                </tspan>
            </text>
            <text
                transform="translate(336.24 138.19)"
                fill="#405184"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="10"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Original Project
                </tspan>
            </text>
            <text
                transform="translate(59.09 138.19)"
                fill="#405184"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="10"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Project Copy
                </tspan>
            </text>
            <text
                transform="translate(322.12 48.49)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="12"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Linked Program
                </tspan>
            </text>
            <text
                transform="translate(26.79 48.49)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="12"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Publishing Program
                </tspan>
            </text>
            <path
                id="Path_2043-2"
                d="m148.86,167.97l-8.74,8.62h0s-.06.06-.09.1l-.04.04c-.21.25-.35.54-.41.86h0c-.01.06-.02.12-.03.19s-.01.13-.01.2c0,.07,0,.13.01.2,0,.06.02.12.03.19h0c.06.32.2.61.41.86.01.02.03.03.04.04.03.03.06.07.09.1h0l8.74,8.62c.77.76,2.01.75,2.77-.02.76-.77.75-2.01-.02-2.76h0l-5.35-5.28h14.35c1.08,0,1.96-.88,1.96-1.96s-.88-1.96-1.96-1.96h-14.35l5.35-5.28c.79-.74.82-1.98.08-2.76-.74-.79-1.98-.82-2.76-.08-.02.02-.05.05-.07.07"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_2044-2"
                d="m174.55,177.98c0,1.08-.88,1.95-1.95,1.96h-2.81c-1.08,0-1.95-.88-1.95-1.96s.88-1.96,1.95-1.96h2.81c1.08,0,1.95.88,1.95,1.96"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_2045-2"
                d="m291.37,188l8.74-8.62h0s.06-.06.09-.1l.04-.04c.21-.25.35-.54.41-.86h0c.01-.06.02-.12.03-.19s.01-.13.01-.2c0-.07,0-.13-.01-.2,0-.06-.02-.12-.03-.19h0c-.06-.32-.2-.61-.41-.86-.01-.02-.03-.03-.04-.04-.03-.03-.06-.07-.09-.1h0l-8.74-8.62c-.77-.76-2.01-.75-2.77.02-.76.77-.75,2.01.02,2.76h0l5.35,5.28h-14.35c-1.08,0-1.96.88-1.96,1.96s.88,1.96,1.96,1.96h14.35l-5.35,5.28c-.79.74-.82,1.98-.08,2.76.74.79,1.98.82,2.76.08.02-.02.05-.05.07-.07"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_2046-2"
                d="m265.68,177.98c0-1.08.88-1.95,1.95-1.96h2.81c1.08,0,1.95.88,1.95,1.96s-.88,1.96-1.95,1.96h-2.81c-1.08,0-1.95-.88-1.95-1.96"
                fill="#44b649"
                stroke-width="0" />
            <g id="Group_671-2">
                <g id="Group_281-2">
                    <g clip-path="url(#clippath-1)">
                        <g id="Group_280-2">
                            <g id="Group_252-2">
                                <g id="Group_251-2">
                                    <g clip-path="url(#clippath-2)">
                                        <g id="Group_250-2">
                                            <path
                                                id="Path_901-2"
                                                d="m183.27,177.95v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#44b649"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="Group_255-2">
                                <g id="Group_254-2">
                                    <g clip-path="url(#clippath-3)">
                                        <g id="Group_253-2">
                                            <path
                                                id="Path_902-2"
                                                d="m191.71,177.95v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#44b649"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="Group_258-2">
                                <g id="Group_257-2">
                                    <g clip-path="url(#clippath-4)">
                                        <g id="Group_256-2">
                                            <path
                                                id="Path_903-2"
                                                d="m200.14,177.95v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#44b649"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="Group_273-2">
                                <g id="Group_272-2">
                                    <g clip-path="url(#clippath-9)">
                                        <g id="Group_271-2">
                                            <path
                                                id="Path_908-2"
                                                d="m242.32,177.95v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#44b649"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="Group_276-2">
                                <g id="Group_275-2">
                                    <g clip-path="url(#clippath-10)">
                                        <g id="Group_274-2">
                                            <path
                                                id="Path_909-2"
                                                d="m250.75,177.95v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#44b649"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="Group_279-2">
                                <g id="Group_278-2">
                                    <g clip-path="url(#clippath-11)">
                                        <g id="Group_277-2">
                                            <path
                                                id="Path_910-2"
                                                d="m259.19,177.95v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#44b649"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <path
                id="Path_2320"
                d="m223.78,170.13c.38-.17.74-.38,1.08-.62v1.55c0,.34-.25.78-.9,1.2.71-.04,1.42.06,2.09.3v-5.06c0-1.2-1.04-2.09-2.27-2.65-3.13-1.23-6.61-1.23-9.74,0-1.22.56-2.27,1.45-2.27,2.65v10.71c0,1.2,1.04,2.09,2.27,2.65,1.54.64,3.2.95,4.87.92.62,0,1.24-.04,1.85-.12-.37-.32-.7-.69-.97-1.1-.29.02-.58.03-.88.03-1.5.03-2.99-.25-4.38-.82-1.14-.52-1.57-1.12-1.57-1.56v-1.55c.34.25.7.46,1.08.62,1.54.64,3.2.95,4.87.92h.03c-.04-.4-.04-.79,0-1.19h-.03c-1.5.03-2.99-.25-4.38-.82-1.14-.52-1.57-1.12-1.57-1.56v-1.55c.34.25.7.46,1.08.62,1.54.64,3.2.95,4.87.92.31,0,.62,0,.92-.03.35-.52.8-.98,1.31-1.35-.74.13-1.48.19-2.23.19-1.5.03-2.99-.25-4.38-.82-1.14-.52-1.57-1.12-1.57-1.56v-1.55c.34.25.7.46,1.08.62,3.13,1.23,6.61,1.23,9.74,0m-10.82-2.65c0-.45.42-1.04,1.57-1.56,2.82-1.09,5.94-1.09,8.76,0,1.14.52,1.57,1.12,1.57,1.56s-.42,1.04-1.57,1.56c-2.82,1.09-5.94,1.09-8.76,0-1.14-.52-1.57-1.12-1.57-1.56"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2321"
                d="m227.88,176.86l-.18-.05c-.05,0-.1-.04-.15-.06-.37-.2-.5-.66-.3-1.03l.09-.16c.2-.37.06-.83-.31-1.03-.23-.12-.5-.12-.72,0l-.16.09s-.1.05-.15.06c-.4.12-.83-.11-.95-.52l-.05-.18c-.12-.4-.54-.63-.95-.52-.25.07-.44.27-.52.52l-.05.18c0,.05-.04.1-.06.15-.2.37-.66.51-1.03.31h0l-.16-.09c-.37-.2-.83-.06-1.03.31-.12.23-.12.5,0,.73l.09.16s.05.1.06.15c.12.4-.11.83-.51.94h0l-.18.05c-.4.12-.63.54-.52.95.07.25.27.44.52.52l.18.05c.05,0,.1.03.15.06.37.2.51.66.31,1.03h0l-.09.16c-.2.37-.06.83.31,1.03.23.12.5.12.73,0l.16-.09s.1-.05.15-.06c.4-.12.83.11.95.51l.05.18c.12.4.54.63.95.52.25-.07.44-.27.52-.52l.05-.18c.02-.05.04-.1.06-.15.2-.37.66-.51,1.03-.31h0l.16.09c.37.2.83.06,1.04-.31.12-.23.12-.5,0-.72l-.09-.16s-.05-.1-.06-.15c-.12-.4.11-.83.51-.94h0l.18-.05c.4-.12.63-.54.52-.95-.07-.25-.27-.44-.52-.52m-3.62,2.51c-.99,0-1.78-.8-1.78-1.78s.8-1.78,1.78-1.78,1.78.8,1.78,1.78-.8,1.78-1.78,1.78"
                fill="#555"
                stroke-width="0" />
            <text
                transform="translate(205.62 188.17)"
                fill="#555"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="6"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Sends Data
                </tspan>
            </text>
        </g>
    </svg>
</template>
